// extracted by mini-css-extract-plugin
export default {"active":"serviceDrop_active__1b-4G","notactive":"serviceDrop_notactive__sG71M"};